import stateApi from '@/api/stateApi';
import IndexRecommendationAlert from '@/components/indexRecommendationAlert';
import { LoadingIndicator } from '@/components/loadingIndicator';
import { Group, Stack } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import calculateRecommendations from 'lib/calculateRecommendations';
import { useCallback } from 'react';

export const Route = createFileRoute('/recommendations/')({
  component: RouteComponent,
});

function RouteComponent() {
  const ready = stateApi.state.useStore((x) => x.actual.ready);
  const recommendations = stateApi.mergedCollections.useStore(useCallback(calculateRecommendations, []));

  if (!ready) {
    return (
      <Group flex={1} justify="center" align="center">
        <LoadingIndicator />
      </Group>
    );
  }

  return (
    <Stack
      css={{
        padding: 'var(--mantine-spacing-md)',
      }}
    >
      {recommendations.map(({ collection, recommendation }, index) => (
        <IndexRecommendationAlert key={index} collection={collection} recommendation={recommendation} />
      ))}
    </Stack>
  );
}
